import { FC } from 'react';

import { useCan } from '../../permissions';
import OnlineUsersIndicator from './OnlineUsersIndicator';
import TicketsIndicator from './TicketsIndicator';
import RemindersIndicator from '../Reminders/RemindersIndicator';

/**
 * Status icons in the header. Admin ones are gated by their permission here, not inside the indicator,
 * so a user without the key never mounts the component — no poll, no socket listener and no request
 * that would only come back 403. The tickets icon is for everyone: it is told whether the viewer can
 * triage, and asks the board endpoints only if so.
 */
const HeaderIndicators: FC = () => {
    const can = useCan();
    return (
        <>
            {can('admin.user:view') && <OnlineUsersIndicator />}
            {/* Everyone has their own tickets; the key only adds the untriaged list on top. */}
            <TicketsIndicator canTriage={can('system.tickets:view')} />
            {/* Personal reminders — everyone has their own; the due pop-up mounts with it. */}
            <RemindersIndicator />
        </>
    );
};

export default HeaderIndicators;
